"use client";;
import useNoScroll from "@/app/hooks/useNoScroll";
import { GetNextIndex, GetPrevIndex } from "@/app/ui/utils/ProjectsImageSwitcher";
import Spinner from "@/app/ui/utils/Spinner";
import { cn, sleep } from "@/lib/utils";
import { MouseEvent, useContext, useEffect, useRef, useState, WheelEvent } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import { useSwipeable } from 'react-swipeable';
import YouTube, { YouTubeEvent, YouTubePlayer } from 'react-youtube';
import { ShortsNavigatorContext } from "./ShortsNavigator_client";
export default function ShortsNavigator_fullscreen({ videoIdList }: { videoIdList: string[] }) {
    const ctx = useContext(ShortsNavigatorContext)
    const { currentVideo, setCurrentVideo } = ctx;

    const [animate, setAnimate] = useState<null | "down" | "up">(null)
    const [animateAs, setAnimateAs] = useState<"in" | "out">("in");
    const [offset, setOffset] = useState(0);


    const playerRef = useRef<YouTubePlayer | null>(null);

    /** swipe handlers for mobile  */
    const swipeHandlers = useSwipeable({
        onSwiping: (e) => setOffset(Math.sign(e.deltaY) * Math.min(Math.abs(e.deltaY + 10), 100)),
        "delta": 10,
        swipeDuration: 1 * 1000,
        "onSwipedDown": () => ChangeShort(-1),
        "onSwipedUp": () => ChangeShort(1),
    });

    useNoScroll(ctx.isOpen);

    //debounce touche movement
    useEffect(() => {
        const tout = setTimeout(() => {
            setOffset(0)
        }, 500);
        return () => {
            clearTimeout(tout);
        }
    }, [offset])



    async function ScrollWheelHandler(e: WheelEvent<HTMLElement>) {
        const direction = Math.sign(e.deltaY);
        if (direction == 0)//if side scroll
            return;
        ChangeShort(direction)
    }
    /** start video swipe/change logic */
    async function ChangeShort(direction = 1 | -1) {
        if (animate)// if already animating
            return;

        //get the next/pre video & also cycle if got to the end
        const newVideoID = direction == 1 ? GetNextIndex(videoIdList, currentVideo) : GetPrevIndex(videoIdList, currentVideo);

        //set animating direction
        setAnimate(direction == 1 ? "down" : "up"); //also auto-triggers animation
        setAnimateAs("out");
        await sleep(0.1) // minimal wait time to allow animation start - there is aso delay when youtube finish loads

        setCurrentVideo(newVideoID);
    }

    /** handle when a new video gets loaded - updating player ref & playing ending of animation */
    async function IFrameLoadHandler(event: YouTubeEvent) {
        playerRef.current = event.target; //update the handler

        setAnimateAs(pre => pre == "in" && "out" || "in");
        await sleep(0.5) // wait for animation to end

        setAnimate(null); //reset animation state
    }

    /** custom play/pause */
    function TogglePlay(e: MouseEvent<HTMLDivElement>) {
        e.preventDefault();
        e.stopPropagation();

        if (!playerRef.current)
            return;

        const p = playerRef.current;
        p.getPlayerState() == 1 && playerRef.current.pauseVideo() || playerRef.current.playVideo();
    }

    return (
        <section className='w-lvw h-lvh bg-black/60 backdrop-blur fixed inset-0 z-50 !m-0 flex items-center justify-center group/short'
            onWheel={ ScrollWheelHandler }
            onClick={ () => ctx.setIsOpen(false) }
            { ...swipeHandlers }
        >
            <div className={ cn("relative h-full max-w-screen-sm bg-slate-800 text-4xl overflow-hidden flex items-center sm:rounded-3xl") }
                onClick={ TogglePlay }>
                <span className={ cn("absolute top-3 left-3 cursor-pointer rounded-full z-10 transition-transform",
                    "drop-shadow-lg border border-red-700 bg-white text-red-600 hover:text-red-700 active:text-red-500 active:scale-95 active:rotate-180"
                ) }
                    onClick={ () => ctx.setIsOpen(false) }
                >
                    <AiFillCloseCircle />
                </span>
                <Spinner className="text-8xl absolute inset-0 m-auto" />

                <div className={ cn("relative w-full h-full aspect-[9/16] sm:rounded-3xl fill-mode-both",
                    animate && "duration-500",
                    animateAs == "in" && animate == "up" && "animate-in slide-in-from-top ",
                    animateAs == "out" && animate == "up" && "animate-out slide-out-to-bottom",

                    animateAs == "in" && animate == "down" && "animate-in slide-in-from-bottom",
                    animateAs == "out" && animate == "down" && "animate-out slide-out-to-top") }>

                    <YouTube className={ cn("relative w-full h-full ",
                        "[&_iframe]:h-full [&_iframe]:w-full",
                        "pointer-events-none",
                        "transition-transform duration-100"
                    ) }
                        style={ { transform: `translateY(${offset}px)` } }
                        onReady={ IFrameLoadHandler }
                        onStateChange={ () => { playerRef.current.getPlayerState() == 0 && playerRef.current.playVideo() } }
                        videoId={ currentVideo }
                        opts={ {
                            "playerVars": {
                                "autoplay": 1,
                                "cc_load_policy": 1,
                                "controls": 0,
                                "enablejsapi": 1,
                                "fs": 0,
                                "hl": "he",
                                "loop": 1,
                                "rel": 0,
                            }
                        } }
                        //src={ getEmbedLink(currentVideo) }
                        loading="lazy"
                        title="YouTube short video player"
                    />
                </div>

            </div>

        </section>
    )
}
